import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RefundConfigComponent } from 'src/app/popups/refund-config/refund-config.component';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { ActiveInactiveFor, InteractionType, KeyValueSet, LocalService, PageKey, Status, TriggeredEvent, Wrapper10Initialization } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';
import { AssociatedAccountsComponent } from '../../popups/associated-accounts/associated-accounts.component';
import { DelivererConfigComponent } from '../../popups/deliverer-config/deliverer-config.component';
import { EditSystemInfoComponent } from '../../popups/edit-system-info/edit-system-info.component';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["table"];
  source: Wrapper10Initialization; maxBodyHeight = 0; activeInactiveFor = ActiveInactiveFor;
  isOpenCreateAccount = false; isOpenBulkUserUpload = false; isArchive: boolean = false;

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private router: Router, private languageManagementService: LanguageManagementService, private profileManagementService: ProfileManagementService, private modalService: NgbModal, public configurationManagementService: ConfigurationManagementService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.configurationManagementService.ensurePageActions(PageKey.Users);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.onLoad();
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight(10);
    this.cdr.detectChanges();
  }

  onChangeAsCountry() {
    if (this.localService && this.localService.selected && this.localService.getLoginAsCountryCode()) {
      const ctryCode = this.localService.getLoginAsCountryCode() == this.localService.asCtryCode ? this.localService.asCtryCode : (this.localService.getLoginAsCountryCode() + '-' + this.localService.asCtryCode);

      this.router.navigate([['/users', ctryCode, this.localService.selected.user, InteractionType.Bill_PnixSoft].join('/')]);
    }
  }

  isLoading = false;
  onLoad() {
    if (!this.isLoading) {
      this.isLoading = true;
      if (!this.source) {
        this.profileManagementService.getUserInitialization().subscribe(result => {
          this.source = result;
          this.isLoading = false;
        });
      } else {
        this.profileManagementService.getMembers(this.source.content.paging, this.isArchive).subscribe(result => {
          this.source.content = result;
          this.isLoading = false;
        });
      }
    }
  }

  onClick(index, id = '') {
    switch (index) {
      case 1: {
        this.profileManagementService.getMyDeliverer(id, this.source.locations.selected.key).subscribe(result => {
          const modalRef = this.modalService.open(DelivererConfigComponent);
          modalRef.componentInstance.ctryCode = this.source.locations.selected.key;
          if (result.key == '')
            modalRef.componentInstance.userId = id;
          else
            modalRef.componentInstance.id = result.key;
        });
      } break;
      case 2: {
        const modalRef = this.modalService.open(EditSystemInfoComponent);
        modalRef.componentInstance.id = id;
        modalRef.componentInstance.ctryCode = this.localService.getLoginAsCountryCode();
        modalRef.result.then((result) => {
          if (result.event == TriggeredEvent.Ok) {
            this.onLoad();
          }
        });
      } break;
      case 3: {
        const modalRef = this.modalService.open(AssociatedAccountsComponent);
        modalRef.componentInstance.userOrBusinessId = id;
        modalRef.componentInstance.isUser = true;
        modalRef.componentInstance.countryCode = this.source.locations.selected.key;
      } break;
      case 4: {
        const modalRef = this.modalService.open(RefundConfigComponent);
        modalRef.componentInstance.userOrBusinessId = id;
        modalRef.componentInstance.interactionType = InteractionType.User;
        modalRef.componentInstance.countryCode = this.source.locations.selected.key;
      } break;
      case 5: {
        this.localService.viewAsCountryCodeUserId = { key: this.source.locations.selected.key, value: id, isSelected: true } as KeyValueSet;
        this.localService.viewAsReturnCountryCodeUserId = { key: this.localService.getLoginAsCountryCode(), value: this.localService.selected.user, isSelected: true } as KeyValueSet;
        this.localService.onAutoLogin();
      } break;
      case 6: {
        this.isOpenCreateAccount = true;
      } break;
      case 7: {
        this.isOpenBulkUserUpload = true;
      } break;
    }
  }

  onCountryUpdated(e) {
    this.source.locations.selected.key = e;
  }

  onCloseCreateAccount(result) {
    if (result) {
      if (result.event == TriggeredEvent.Ok) {
        this.onLoad();
      }
    }
  }

  onCloseBulkUploadUser(result) {
    if (result) {
      if (result.event == TriggeredEvent.Ok) {

      }
    }
  }

  onActiveInactiveStatus(strId: string, activeInactiveFor: ActiveInactiveFor) {
    this.profileManagementService.activeInactiveStatus(strId, activeInactiveFor).subscribe(result => {
      if (result.status == Status.Success || result.status == Status.SuccessWithMoreAction) {
        const updatedItem = this.source.content.items.find(x => x.key == strId);

        switch (activeInactiveFor) {
          case ActiveInactiveFor.ArchiveUser: {
            updatedItem.v7 = result.id;
          } break;
        }
      }
    });
  }
}
